const Routes = Object.freeze(
  {
    DASHBOARD: "/",
    LOGIN: "/login",
    REGISTER: "/register",
    FORGOT_PASSWORD: "/forgot-password",
    RESET_PASSWORD: "/reset-password",
    CONFIRM_EMAIL: "/confirm-email",
    PAYMENT_SELECT: "/payment-select",
    DATA_TABLE: "/data-table",
    INPUTS: "/inputs",
    SANDBOX: "/sandbox",
    EMAIL_TEMPLATE: "/email-template",
    PASSWORD_CHANGED_CONFIRMATION: "/password-changed",
    EMAIL_CHANGED_CONFIRMATION: "/email-changed",
    PREFERRED_NAME: "/preferred-name",
    ONBOARDING__WELCOME: "/onboarding/welcome",
    ONBOARDING__START: "/onboarding/start",
    ONBOARDING__DNA: "/onboarding/dna",
    ONBOARDING__DNA_CONFIRMATION: "/onboarding/dna-confirmation",
    ONBOARDING__TRIP_CREATE: "/onboarding/trip-create",
    DNA_EDIT: "/dna/edit",
    TRIP: "/trip/:id",
    TRIP__EDIT: "/trip/:id/edit",
    TRIP__CONFIRM: "/trip/:id/confirm",
    PROFILE: "/profile",
    SETTINGS: "/settings",
    TRIAL: "/trial",
    SUBSCRIBE: "/subscribe",
    UPGRADE: "/upgrade",
    AFTER_PAYMENT_LANDING: "/payment-successful",
    POLICY: "/policy",
    TERMS: "/terms",
  } as const,
);

export default Routes;

export type AvailableRoutes = (typeof Routes)[keyof typeof Routes];
